import { getAlbumCardsData } from '_api/bbs/post'
import Vue from 'vue'
const CptName = 'ComAlbumCard'
class AlbumCards {
  #promise
  #resolve
  #article
  constructor (article) {
    this.cards = []
    this.#article = article
    this.#promise = new Promise(resolve => this.#resolve = resolve)
  }
  
  addCards (node) {
    if (node.dataset && node.dataset.albumid) {
      this.loadCard()
      let card = this.generateCardData(node)
      this.cards.push(card)
      return card
    }
    return node
  }

  loadCard () {
    if (!this.is_load_card) {
      this.dynImport()
      this.is_load_card = true
    }
  }

  dynImport () {
    import('./index.vue').then(cpt => {
      Vue.component(CptName, cpt.default)
      this.cards.forEach(item =>item.cpt = CptName)
    })
  }

  generateCardData (node) {
    return {
      cpt: 'ComCardPlaceholder',
      data: {
        request: this.#promise,
        id: node.dataset.albumid,
        placeholder_style: {
          height: '80px',
        }
      }
    }
  }

  request () {
    if (this.cards.length == 0 || this.#article.options.preload) return
    this.#resolve(
      getAlbumCardsData({}, {
        list_ids: JSON.stringify(this.cards.map(item => item.data.id))
      })
    )
    // this.promise = this.promise.then(resolve => this.resolve = resolve)
  }
}
export default AlbumCards